import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

/**
 * Guard que restringe acesso a rotas exclusivas de usuarios com categoriaAcessoMaster.
 * Verifica o flag salvo no sessionStorage/localStorage durante o login.
 */
export const masterAccessGuard: CanActivateFn = () => {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  if (!isPlatformBrowser(platformId)) {
    return router.createUrlTree(['/sem-permissao']);
  }

  const isMaster =
    sessionStorage.getItem('categoriaAcessoMaster') === 'true' ||
    localStorage.getItem('categoriaAcessoMaster') === 'true';

  return isMaster ? true : router.createUrlTree(['/sem-permissao']);
};
